// Textos de la BÚSQUEDA GLOBAL (search-context + global-search). Los 5 textos
// del trigger/placeholder siguen en el diccionario global ('busqueda.*').
// Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosBusqueda = defineTextos({
  // Badge del módulo de cada resultado (SEARCH_MODULE_LABEL → estas claves)
  modInventory: 'Inventario',
  modMenu: 'Carta',
  modTables: 'Mesas',
  modOrders: 'Pedidos',
  modReservations: 'Reservas',
  modBilling: 'Facturas',
  modPurchases: 'Costos y Gastos',
  modTerceros: 'Terceros',

  // Sub-títulos del índice client-side (legacy, search-context)
  pers: 'pers',
  persSep: 'pers ·',
  proveedor: 'Proveedor',
  cliente: 'Cliente',

  // Modal
  cerrar: 'Cerrar',
  sinResultados: 'Sin resultados para "{q}"',
  probaOtraPalabra: 'Probá con otra palabra o un código.',
  arriba: 'Arriba',
  abajo: 'Abajo',
  abrir: 'Abrir',
  escParaCerrar: 'Esc para cerrar',
  buscando: 'Buscando…',
  empiezaAEscribir: 'Empieza a escribir',
  ayuda: 'Busca en todos los módulos: inventario, carta, mesas, pedidos, reservas, facturas, costos y gastos, proveedores y clientes. Por nombre, código, mesa, cliente, NIT o folio.',
}, {
  modInventory: 'Inventory',
  modMenu: 'Menu',
  modTables: 'Tables',
  modOrders: 'Orders',
  modReservations: 'Reservations',
  modBilling: 'Invoices',
  modPurchases: 'Costs & Expenses',
  modTerceros: 'Third parties',

  pers: 'guests',
  persSep: 'guests ·',
  proveedor: 'Supplier',
  cliente: 'Customer',

  cerrar: 'Close',
  sinResultados: 'No results for "{q}"',
  probaOtraPalabra: 'Try another word or a code.',
  arriba: 'Up',
  abajo: 'Down',
  abrir: 'Open',
  escParaCerrar: 'Esc to close',
  buscando: 'Searching…',
  empiezaAEscribir: 'Start typing',
  ayuda: 'Searches every module: inventory, menu, tables, orders, reservations, invoices, costs and expenses, suppliers and customers. By name, code, table, customer, NIT or folio.',
});
